import PropTypes from 'prop-types';
import InfoPanel from '../InfoPanel/InfoPanel';
import { NOTE_DISCLOSURE_MESSAGE } from './constants';

const NoteDisclosure = ({ className }) => <InfoPanel className={className} message={NOTE_DISCLOSURE_MESSAGE} />;

NoteDisclosure.propTypes = {
  className: PropTypes.string,
};

NoteDisclosure.defaultProps = {
  className: '',
};

export default NoteDisclosure;
